'use client';

import type { ReactNode } from 'react';
import SalesCallbackProvider from '@/components/sales-callback/SalesCallbackProvider';
import SalesCallbackSection from '@/components/sales-callback/SalesCallbackSection';

interface ProductDetailClientProps {
  children: ReactNode;
}

export default function ProductDetailClient({ children }: ProductDetailClientProps) {
  return (
    <SalesCallbackProvider>
      <SalesCallbackSection mode="page" dwellMs={5000}>
        {children}
      </SalesCallbackSection>
    </SalesCallbackProvider>
  );
}
